var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between"},[_c('h1',{staticClass:"text-lg font-bold text-gray-900"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }